import { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuth';

const NewPatient = ({ newPatientCallback }) => {
  const history = useHistory();
  const initialFormState = {
    patient_number: '',
  };
  const [isSending, setIsSending] = useState(false);
  const [formState, setFormState] = useState(initialFormState);
  const [error, setError] = useState(true);
  const { token } = useAuthContext();

  const handleFormStateChange = ({ name, value }) => {
    const formStateCopy = Object.assign({}, formState);
    formStateCopy[name] = value;
    setFormState(formStateCopy);
  };

  // useCallback example taken from https://stackoverflow.com/questions/55647287/how-to-send-request-on-click-react-hooks-way
  const sendRequest = useCallback(async () => {
    async function submitNewPatient() {
      console.log( 'token: ' + token)
      await fetch('/hadi/add_patient', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify(formState),
      })
        .then((res) => {
          if (res.status !== 200) {
            setError(res.statusText);
            newPatientCallback(false);
          } else {
            setError('');
            newPatientCallback(true);
            history.goBack();
          }
        })
        .catch((error) => {
          setError(error);
          console.error('There was an error!', error);
          newPatientCallback(false);
        });
      setIsSending(false);
    }
    // don't send again while we are sending
    if (isSending) return;
    // update state
    setIsSending(true);
    // send the actual request
    await submitNewPatient();
  }, [isSending, formState]); // update the callback if the state changes

  const handleSubmit = async (e) => {
    e.preventDefault();
    await sendRequest();
  };

  const hasError = !!(error && error.length);

  return (
    <div className="container login-container">
      <div className="row">
        <div className="col-md-6 offset-md-3 login-form">
          <h3>Register a new HADI Patient</h3>
          <form className="main-form">
            <div className="form-group">
              <input
                type="text"
                name="patient_number"
                className={`form-control ${hasError ? 'is-invalid' : ''}`}
                placeholder="Patient Phone Number"
                required
                value={formState['patient_number']}
                onChange={(e) => handleFormStateChange(e.target)}
              />
              <div className="invalid-feedback">Please try again.</div>
            </div>

            <button onClick={handleSubmit} className="btn btn-primary w-100">
              {isSending ? (
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                'Register New Patient'
              )}
            </button>
            {hasError && <div className="text-danger">{error}</div>}
            <button
              onClick={() => history.goBack()}
              className="btn btn-secondary w-100 mt-3"
            >
              Cancel
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewPatient;
